import { type Role } from "@/models/role/role.model"
import type { AxiosResponse } from "axios"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import type { IRole } from "@/interfaces/api/role/role.interface"

export class RoleRepository {
  async create(role: Role, knownBusinessEntityContactId: string): Promise<AxiosResponse> {
    return new HTTPRequestBuilder(
      HTTPMethods.POST,
      `core/known-business-entities-contacts/${knownBusinessEntityContactId}/roles/`
    )
      .setData(role)
      .build()
      .execute()
  }

  async update(
    knownBusinessEntityContactId: string,
    roleId: string,
    role: IRole
  ): Promise<AxiosResponse> {
    return new HTTPRequestBuilder(
      HTTPMethods.PUT,
      `core/known-business-entities-contacts/${knownBusinessEntityContactId}/roles/${roleId}/`
    )
      .setData(role)
      .build()
      .execute()
  }

  async delete(knownBusinessEntityContactId: string, roleId: string): Promise<AxiosResponse> {
    return new HTTPRequestBuilder(
      HTTPMethods.DELETE,
      `core/known-business-entities-contacts/${knownBusinessEntityContactId}/roles/${roleId}/`
    )
      .setExpectedStatusCode(204)
      .build()
      .execute()
  }
}
